var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistoryLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "none",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.00001C17.523 2.00001 22 6.47701 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12H4C4.00022 13.9155 4.6877 15.7673 5.93749 17.2189C7.18727 18.6704 8.9164 19.6254 10.8106 19.9102C12.7048 20.195 14.6382 19.7907 16.2596 18.7708C17.881 17.7509 19.0826 16.1831 19.646 14.3524C20.2095 12.5217 20.0974 10.5495 19.3301 8.79446C18.5628 7.03939 17.1913 5.61788 15.4648 4.7883C13.7382 3.95872 11.7714 3.77615 9.9217 4.27377C8.07199 4.77138 6.46223 5.91615 5.385 7.50001H8V9.50001H2V3.50001H4V6.00001C4.93039 4.75689 6.13801 3.74802 7.52681 3.05362C8.91561 2.35922 10.4473 1.99845 12 2.00001ZM13 7.00001V11.585L16.243 14.828L14.828 16.243L11 12.413V7.00001H13Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryLine);
export default __webpack_public_path__ + "static/media/history-line.ab43b87c6ebd19b734297b7607c7ecc3.svg";
export { ForwardRef as ReactComponent };